import { render, staticRenderFns } from "./AlertRegistrationWarnings.vue?vue&type=template&id=b9efcccc&"
import script from "./AlertRegistrationWarnings.vue?vue&type=script&lang=js&"
export * from "./AlertRegistrationWarnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports